import { MeasurementToolActionTypes } from "./measurementToolActionsConstants";

export function TURN_OFF_MEASUREMENT_TOOL(hide: boolean = false) {
  return {
    type: MeasurementToolActionTypes.TURN_OFF_MEASUREMENT_TOOL,
    payload: hide,
  };
}

export function TURN_ON_MEASUREMENT_TOOL() {
  return {
    type: MeasurementToolActionTypes.TURN_ON_MEASUREMENT_TOOL,
  };
}

export function ADD_STARTING_POINT(coords: pixelPoint) {
  return {
    type: MeasurementToolActionTypes.ADD_STARTING_POINT,
    payload: {
      x: coords.x,
      y: coords.y,
    },
  };
}

export function ADD_ENDING_POINT(coords: pixelPoint) {
  return {
    type: MeasurementToolActionTypes.ADD_ENDING_POINT,
    payload: {
      x: coords.x,
      y: coords.y,
    },
  };
}

export function START_NEW_MEASUREMENT() {
  return {
    type: MeasurementToolActionTypes.START_NEW_MEASUREMENT,
  };
}

export function DELETE_MEASUREMENT(index: number) {
  return {
    type: MeasurementToolActionTypes.DELETE_MEASUREMENT,
    payload: {
      index,
    },
  };
}

export function CLEAR_ALL_MEASUREMENTS() {
  return {
    type: MeasurementToolActionTypes.CLEAR_ALL_MEASUREMENTS,
  };
}

export function RESET_CURRENT_MEASUREMENT() {
  return {
    type: MeasurementToolActionTypes.RESET_CURRENT_MEASUREMENT,
  };
}

export function SET_MEASUREMENT_HOVER(isHovering: boolean) {
  return {
    type: MeasurementToolActionTypes.SET_MEASUREMENT_HOVER,
    payload: {
      isHovering,
    },
  };
}
